import getCookie from '@capsule/get-cookie'
import { getMediaPlayer } from './shared/utils.js'
import type { AbtastyEvent } from './types.js'

type AutomaticEvents = {
	auth_id: string | null
	media_player: string
	page_title: string
}

/**
 * Get automatic events to send to DataLayer
 @returns List of automatic events
 */
function getAutomaticEvents(): AutomaticEvents {
	return {
		auth_id: getCookie('authId'),
		media_player: getMediaPlayer(),
		page_title: document.title
	}
}

// Non exported function should not be executed in Jest environment
if (!window.navigator.userAgent.includes('jsdom')) {
	window.dataLayer.push(getAutomaticEvents())
}

/**
 * Send PMC profile paywall subscriber data to DataLayer
 */
export function paywallSubscriber() {
	window.pmcstarter(async (myPmc) => {
		const pmcProfile = await myPmc.getProfile()
		let status = false

		if (pmcProfile) {
			const subscription = pmcProfile?.paymentSubscriptions?.rights.filter((key) => {
				return key === 'paid-web-content'
			})
			if (subscription?.length) {
				status = true
			}
		}

		window.dataLayer.push({ paywall_subscriber: status })
	})
}

/**
 * Send ABTasty campaign to DataLayer
 */
export function abTasty() {
	document.addEventListener('abtasty_executedCampaign', (event) => {
		const abtastyEvent = event as CustomEvent<AbtastyEvent>
		window.dataLayer.push({ event: 'dispatch', ab_test_variation: abtastyEvent.detail.variationId })
	})
}

export const _exportedForTesting = {
	getAutomaticEvents
}
